// todo: Логика шапки растекается, но нет никого стандартного решения для данной ситуации из beefuture
export var getHeaderElement = function getHeaderElement() {
  return document.querySelector('[data-component="site-header-container"]');
};